export const notificationPurposes = [
  { id: 100, name: 'Community Alert' },
  { id: 101, name: 'Event Attendee Reminder' },
  // No 102 here, since we handle it separately in the UI
  // { id: 102, name: 'Non-Promotional Subscription' },
  { id: 103, name: 'Pairing Update' },
  { id: 104, name: 'Application Update' },
  { id: 105, name: 'Account Update' },
  { id: 106, name: 'Payment Update' },
  { id: 107, name: 'Personal Finance Update' },
  { id: 108, name: 'Shipping Update' },
  { id: 109, name: 'Reservation Update' },
  { id: 110, name: 'Issue Resolution' },
  { id: 111, name: 'Appointment Update' },
  { id: 112, name: 'Game Event' },
  { id: 113, name: 'Transportation Update' },
  { id: 114, name: 'Feature Functionality Update' },
  { id: 115, name: 'Ticket Update' },
];
